import React, { useContext, useState } from 'react';
import pic3 from '../images/mahikacafe3.jpg';
import './Menu.css';
import { menu_list } from '../images/images';
import BevDisplay from '../BevDisplay/BevDisplay';
import { RecommendationContext } from '../context/RecommendationContext';
import { StoreContext } from '../context/StoreContext';

export default function Menu({ category, setCategory}) {
  const [searchQuery, setSearchQuery] = useState("");
  const { recommendation } = useContext(RecommendationContext);
  const {url} = useContext(StoreContext);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };


  return (
    <>
      <img src={pic3} className="pic3" alt="" />

      <div className="explore-menu" id="explore-menu">
        <div className="menu-content">
          <div className='category-list'>
            <div className="explore-menu-list">
              {menu_list.map((item, index) => (
                <div 
                  onClick={() => setCategory(prev => prev === item.menu_name ? "All" : item.menu_name)} 
                  key={index} 
                  className="explore-menu-list-item"
                >
                  <img className={category === item.menu_name ? "active" : ""} src={item.menu_image} alt="" />
                  <p>{item.menu_name}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="bev-list">
            <div className='medyoheader'>
              { recommendation && (
                <div className='recommendation'>
                <h3>Recommended Drink for You:</h3>
                <div className="recommendation-grid">
                  <div className="recommendation-item">
                    <p>{recommendation.name}</p>
                  </div>
                  <div className="recommendation-item">
                    <img src={`${url}/images/${recommendation.image}`} alt=""/>
                  </div>
                  <div className="recommendation-item">
                    <p>Sugar Level: {recommendation.sugar}</p>
                  </div>
                </div>
              </div>
              )}
            
            <input 
              type="text" 
              placeholder="Search Beverages" 
              value={searchQuery} 
              onChange={handleSearchChange} 
              className="search-input" // Apply the CSS class here
            />
            </div>
            <BevDisplay category={category} searchQuery={searchQuery} />
          </div>
        </div>
      </div>
    </>
  );
}
